import { render, staticRenderFns } from "./ModalPurchaseRemito.vue?vue&type=template&id=41833874&"
import script from "./ModalPurchaseRemito.vue?vue&type=script&lang=js&"
export * from "./ModalPurchaseRemito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports